import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/exams/file-based/:examId/grades`;
const pathById = `${pathBase}/:attemptId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const grades = {
  get: apiPathFunc(pathById),
  patch: apiPathFunc(pathById),
} as const;
